import React, { useEffect, useRef, useState } from 'react';
import Img from './Img';
import { classIf, filtraParametriche, getAggregationAndBetFromBetId, getBetDescription } from '../data/utils';

function getMarketDescriptionParam(bet){
    const aggregateContainer = getAggregationAndBetFromBetId(bet.cs, 0);
    if (aggregateContainer.market) {
        let desc = aggregateContainer.market.desc;
        desc = desc.replaceAll('@@H1@@', 'X')
                   .replaceAll('@@H2@@', 'Y')
                   .replaceAll('@@H3@@', 'Z')
                   .replaceAll('@@H4@@', 'K')
                   .replaceAll('{{H1}}', 'X')
                   .replaceAll('{{H2}}', 'Y')
                   .replaceAll('{{H3}}', 'Z')
                   .replaceAll('{{H4}}', 'K');
        return desc;
    }
    
    return getBetDescription(bet, true);
}

export default function BetSelector(props) {
    const [toggled, setToggled] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const listener = () => {
            setToggled(false);
        }
        const el = ref.current;
        el.addEventListener('blur', listener);
        return () => el.removeEventListener('blur', listener);
    }, []);

    const bets = filtraParametriche(props.bets);
    const selected = props.selected;
    const desc = selected.parametrica ? getMarketDescriptionParam(selected) : getBetDescription(selected, true);
    const showDropdown = bets.length > 2;

    return (
        <div className="c_25" onClick={() => showDropdown && setToggled(!toggled)} data-disabled={!showDropdown} ref={ref} tabIndex={0}>
            <div className="c_25_1">{desc}</div>
            {showDropdown &&
                <Img className="c_25_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate={toggled ? '180' : ''} />
            }
            {toggled &&
                <div className="c_25_3">
                    {bets.map((b, i) => {
                        if (props.toFilter.has(b.id)) {
                            return null;
                        }

                        const desc = b.parametrica ? getMarketDescriptionParam(b) : getBetDescription(b, true);

                        return (
                            <div key={b.uniqueId} className={"c_25_3_1" + classIf(props.id === b.id, 'active')} onClick={() => props.changeBet(b)}>
                                <div className="c_25_3_1_1">{desc}</div>
                                <div className="c_25_3_1_2"></div>
                            </div>
                        );
                    })}
                </div>
            }
        </div>
    );
}
